/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Box, HStack, Text } from '@chakra-ui/react';
import { CQReactTable } from '@laxmimanogna/code-quick-components';
import { RebuttalIcon, UrgentIcon } from '../../../../constants/IconData';

import { createColumnHelper } from '@tanstack/react-table';
import {
  getAuditStatus,
  MY_AUDITS_ORDERING,
} from '../../../../constants/constants';
import useCQMediaQuery from '../../../../hooks/useCQMediaQuery';
import { format, formatDistanceStrict } from 'date-fns';

import '../style.css';
import { MyAuditContext } from '../../../../providers/MyAuditProvider';
import { renderActionComponent } from '../MyAuditsComponents';
import {
  defaultReactTableProp,
  paginationProps,
} from '../../../../utils/my_audits.utils';
import { useNavigate } from 'react-router-dom';
import { toTitleCase } from '../../../../utils/common.utils';

const columnHelper = createColumnHelper();

const UrgentTable = () => {
  const myAuditContext = useContext(MyAuditContext);
  const navigate = useNavigate();
  const [ordering, setOrdering] = useState('');

  // media query
  const canScroll = useCQMediaQuery({
    lg: false,
    md: false,
    sm: true,
  });

  const { isUpdating, getAuditUrgent, filterParams } = myAuditContext;

  useEffect(() => {
    let searching = !!(filterParams.searchText && filterParams.searchText.trim());
    getAuditUrgent.loadAPI("My Audit", "My Urgent", searching);
  }, [filterParams, getAuditUrgent.showOrdering]);

  useEffect(() => {
    if (MY_AUDITS_ORDERING.includes(ordering)) {
      getAuditUrgent.setParams({ ordering });
    }
  }, [ordering]);

  const columns = useMemo(
    () => [
      columnHelper.accessor('upload_id', {
        header: () => 'Upload #',
        cell: info => {
          return (
            <HStack
              justifyContent={'flex-start'}
              alignItems={'center'}
              spacing={5}
            >
              {info.row.original?.status === 'CLIENT REBUTTAL' ||
                info.row.original?.status === 'REBUTTAL IN PROGRESS' ? (
                <RebuttalIcon style={{ height: 20, width: 20 }} />
              ) : (
                <UrgentIcon />
              )}
              <Text>{info.renderValue()}</Text>
            </HStack>
          );
        },
      }),
      columnHelper.accessor(row => row.uploaded_date, {
        id: 'uploaded_date',
        header: () => <span>Chart Upload</span>,
        cell: info => {
          const cellValue = info.getValue();
          if (!cellValue) {
            return 'N/A';
          }

          return format(new Date(cellValue), 'MM/dd/yyyy');
        },
      }),
      //need to modify
      columnHelper.accessor(row => row.uploaded_date, {
        id: 'audited_date',
        header: () => <span>Audit Upload</span>,
        cell: info => {
          const cellValue = info.getValue();
          if (!cellValue) {
            return 'N/A';
          }

          return format(new Date(cellValue), 'MM/dd/yyyy');
        },
      }),

      columnHelper.accessor(p => p.specialties?.name, {
        header: () => 'Specialties',
        id: 'specialty__name',
        cell: info => {
          const specialties = info.row.original.specialties?.name;

          if (!specialties) {
            return 'N/A';
          }
          return specialties === 'ent' ? 'ENT' : toTitleCase(specialties);
        },
      }),

      columnHelper.accessor(p => p.assigned_qa?.first_name, {
        header: () => 'QA',
        id: 'qa',
        cell: info => {
          const cellValue = info.row.original.assigned_qa;
          if (!cellValue) {
            return 'N/A';
          }

          return `${cellValue.first_name} ${cellValue.last_name}`;
        },
      }),
      columnHelper.accessor('status', {
        header: () => 'Status',
        cell: info => <Text>{getAuditStatus(info.row.original?.status)}</Text>,
      }),

      columnHelper.accessor('updated_date', {
        header: () => 'Last Updated',
        cell: info => {
          let updatedAt = info.getValue();

          updatedAt = updatedAt
            ? formatDistanceStrict(new Date(updatedAt), new Date(), {
              addSuffix: true,
            })
            : 'N/A';

          return (
            <Text>
              {updatedAt !== 'N/A' ? toTitleCase(updatedAt) : updatedAt}
            </Text>
          );
        },
      }),
      columnHelper.accessor(row => row, {
        id: 'actions',
        header: () => 'Actions',
        enableSorting: false,
        cell: info => {
          const obj = info.getValue();
          return renderActionComponent(obj, navigate, myAuditContext);
        },
      }),
    ],
    [myAuditContext.isAuditUploadListLoading]
  );

  function handlePreviousPage() {
    myAuditContext.getAuditUrgent.loadPrevious("My Audit", "My Urgent");
  }

  function handleNextPage() {
    myAuditContext.getAuditUrgent.loadNext("My Audit", "My Urgent");
  }

  function handleSizeChange(size) {
    myAuditContext.getAuditUrgent.loadSize("My Audit", "My Urgent", size );
  }

  function handlePageChangeByNumber(pageNumber) {
    myAuditContext.getAuditUrgent.loadPageByNumber("My Audit", "My Urgent", pageNumber);
  }

  return (
    <Box
      pointerEvents={isUpdating ? 'none' : 'inherit'}
      overflowX={canScroll ? 'scroll' : 'inherit'}
    >
      <CQReactTable
        manualSortBy={true}
        isLoading={myAuditContext.isAuditUploadListLoading}
        data={myAuditContext.auditUrgentList}
        columns={columns}
        {...defaultReactTableProp}
        {...paginationProps(getAuditUrgent)}
        onPreviousPage={handlePreviousPage}
        onNextPage={handleNextPage}
        onSizeChange={handleSizeChange}
        onPageChangeByNumber={handlePageChangeByNumber}
        onAsc={header => {
          setOrdering(header);
        }}
        onDesc={header => {
          setOrdering(`-${header}`);
        }}
      />
    </Box>
  );
};
export default UrgentTable;
